import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Highlights() {
  return (
    <section
      className="intro_section p-100"
      style={{ backgroundColor: "#F4F4F4" }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#644BB1" }}>Highlights</span>
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="">
            <p>
              Anywhere in the world you are, you can use qRoll and get
              notifications, it’s a worldwide app. It is very user-friendly, you
              can create casting calls and easily interact with interested
              people via the chat feature. Users also get 24/7 support services,
              day or night team qRoll is available to help.
            </p>
          </Col>
        </Row>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <StaticImage
              src="../../../images/case-studies/qroll/highlights_img_main.png"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["png"]}
              width={1516}
              height={708}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Highlights;
